import { render } from "./SVGChromeLogo.vue?vue&type=template&id=24298d5e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/svg/SVGChromeLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24298d5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24298d5e', __exports__)) {
    api.reload('24298d5e', __exports__)
  }
  
  module.hot.accept("./SVGChromeLogo.vue?vue&type=template&id=24298d5e", () => {
    api.rerender('24298d5e', render)
  })

}


export default __exports__